import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { RegistrationBody } from "../components/RegistrationBody";

export const Template = (
    props: Immutable<templates.RegistrationDocumentTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <RegistrationBody {...props} />
        </PageSkeleton>
    );
};
